import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Habilitar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "close" : "check"}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Tipo de Cuenta',
                    dataIndex: 'nombreTipoCuenta',
                    key: 'nombreTipoCuenta',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'nombreMoneda',
                    key: 'nombreMoneda',
                    sorter: true
                },
                {
                    title: 'Cuenta Bancaria',
                    dataIndex: 'numeroCuenta',
                    key: 'numeroCuenta',
                    sorter: true
                },
                {
                    title: 'Cuenta Interbancaria',
                    dataIndex: 'cuentaInterbancaria',
                    key: 'cuentaInterbancaria',
                    sorter: true
                },
                {
                    title: 'Entidad',
                    dataIndex: 'nombreEntidad',
                    key: 'nombreEntidad',
                    sorter: true
                },
                {
                    title: 'Cuenta Contable',
                    dataIndex: 'cuentaContable',
                    key: 'cuentaContable',
                    sorter: true
                },
                {
                    title: 'Contabilidad',
                    dataIndex: 'flagContabilidad',
                    key: 'flagContabilidad',
                    align: 'center',
                    sorter: true,
                    render: (value) => {
                        return (<span>{value ? 'SI' : 'NO'}</span>)
                    }
                },
                {
                    title: 'Fecha Apertura',
                    dataIndex: 'fechaAperturaStr',
                    key: 'fechaAperturaStr',
                    sorter: true
                },
                {
                    title: 'Saldo Inicial Debe',
                    dataIndex: 'saldoInicialDebe',
                    key: 'saldoInicialDebe',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Saldo Inicial Haber',
                    dataIndex: 'saldoInicialHaber',
                    key: 'saldoInicialHaber',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },

                {
                    title: 'Visualizar en PDF',
                    dataIndex: 'flagView',
                    key: 'flagView',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "blue" : "red"}>{value ? "SI" : "NO"}</Tag>
                        </div>)
                    }
                },
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}